import api from '../lib/api';
import type { Paginated } from '../types';
import type { Contact, ContactInput } from '../types/crm';

// Single-record endpoints return `{ data: { id, type, attributes: {...} } }`;
// list endpoints return flat records. See operator.service.ts for the rationale.

export const contactService = {
  getAll: async (params?: Record<string, unknown>): Promise<Paginated<Contact>> => {
    const response = await api.get<Paginated<Contact>>('/contacts', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Contact> => {
    const response = await api.get<{ data: { attributes: Contact } }>(`/contacts/${id}`);
    return response.data.data.attributes;
  },

  create: async (data: ContactInput): Promise<Contact> => {
    const response = await api.post<{ data: { attributes: Contact } }>('/contacts', { contact: data });
    return response.data.data.attributes;
  },

  update: async (id: number, data: Partial<ContactInput>): Promise<Contact> => {
    const response = await api.patch<{ data: { attributes: Contact } }>(`/contacts/${id}`, { contact: data });
    return response.data.data.attributes;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/contacts/${id}`);
  },
};

export default contactService;
